import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`The Channel Object`}</h2>
    <p>{`The Channel Object contains channel data with references to the parent and children channels`}</p>
    <div className="props-table">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Property`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Example`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`id:`}</strong>{` `}<em parentName="td">{`number`}</em><br />{`Channel unique ID`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`42`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`Channel relative URL`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"/giphystudios"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`display_name:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The display name of the channel`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"GIPHY Studios"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`parent:`}</strong>{` `}<em parentName="td">{`number`}</em><br />{`Parent Channel ID`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`20`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`slug:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The unique channel slug. This slug is used in the channel URL`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"giphystudios"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`type:`}</strong>{` `}<em parentName="td">{`string`}</em><br /></td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"community"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`content_type:`}</strong>{` `}<em parentName="td">{`string`}</em><br /></td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"gif"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`user:`}</strong>{` `}<a href="/docs/api/schema#user-object">{`User`}</a><br />{`An object containing data about the user associated with this Channel`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`banner_image:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`Channel banner image URL`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"https://media.giphy.com/headers/giphystudios/WWv21rRnktty.jpg"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`short_display_name:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The short display name of the channel`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"GIPHY"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`description:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`Channel description`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"GIPHY Studios is making all the GIFs"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`metadata_description:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`Channel metadata description`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"Making all the GIFs"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`has_children:`}</strong>{` `}<em parentName="td">{`boolean`}</em><br />{`Indicates that the channel has sub-channels`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`is_visible:`}</strong>{` `}<em parentName="td">{`boolean`}</em><br />{`Indicates that the channel is visible`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`is_private:`}</strong>{` `}<em parentName="td">{`boolean`}</em><br />{`Indicates that the channel is private`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`is_live:`}</strong>{` `}<em parentName="td">{`boolean`}</em><br />{`Indicates that the channel is live`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`featured_gif:`}</strong>{` `}<a href="/docs/api/schema#gif-object">{`Gif`}</a><br />{`An object containing data about the channel's featured gif`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`screensaver_gif:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`Channel screensaver GIF's ID`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"4QEPRmyUtrWxKIkMq5"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`tags:`}</strong>{` `}<a href="/docs/api/schema#channel-tag-object">{`Channel Tag[]`}</a><br />{`List of channel tags`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`[]`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`live_since_datetime:`}</strong>{` `}<em parentName="td">{`string`}</em><br /></td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"2020-07-20T03:27:19+0000"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`live_until_datetime:`}</strong>{` `}<em parentName="td">{`string`}</em><br /></td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"2020-07-21T03:27:19+0000"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`ancestors:`}</strong>{` `}<a href="/docs/api/schema#channel-object">{`Channel[]`}</a><br />{`List of parent channels`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`[]`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`syncable_tags:`}</strong>{` `}<a href="/docs/api/schema#channel-tag-object">{`Channel Tag[]`}</a><br />{`List of channel syncable tags`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`[]`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`analytics_response_payload:`}</strong>{` `}<em parentName="td">{`string`}</em><br /></td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"e=ZXZlbnRfdHlwZT1DSEFOTkVMX1NFQVJDSCZjaWQ9YTMxNzNj..."`}</inlineCode></td>
          </tr>
        </tbody>
      </table>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      